import { ContentCluster } from '@app/components/base/content-structure/ContentCluster';
import { IfPermission } from '@app/core/auth/authorization/components/IfPermission';
import { fragmentsPermissions } from '@app/modules/fragments/fragments-permissions';
import { publishMessages } from '@app/modules/social-export/publish';
import { QueryView } from '@mi-front/ui';
import { Box } from '@mui/material';
import { useFragment } from '../../hooks/useFragment';
import { SocialExportPanorama, SocialExportPublishDropdown } from '../social-export-panorama';
import { useFragmentSocialUploadsQuery } from '../social-export-panorama/hooks/useFragmentSocialUploadsQuery';

/**
 * Social export section: permission-gated. Platform bar first, then uploads panorama.
 */
export function FragmentSocialPublishView() {
  const { fragment } = useFragment();
  const uploadsQuery = useFragmentSocialUploadsQuery(fragment.id);

  return (
    <IfPermission permission={fragmentsPermissions.Fragments_SocialPublish}>
      <QueryView query={uploadsQuery} inline>
        {() => {
          const publicationsCount = Array.from(uploadsQuery.data?.values() ?? []).flat().length;

          return (
            <Box>
              <ContentCluster message={publishMessages.publishToSectionTitle} divider={false}>
                <SocialExportPublishDropdown />
              </ContentCluster>
              <ContentCluster
                message={publishMessages.publicationsSectionTitle}
                values={{ count: publicationsCount }}
              >
                <SocialExportPanorama uploadsByPlatform={uploadsQuery.data} />
              </ContentCluster>
            </Box>
          );
        }}
      </QueryView>
    </IfPermission>
  );
}
